var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard_icon",
    transform: "translate(22942 22009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(-22942 -22009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M11,2.05V13H21.95A10,10,0,1,1,11,2.05ZM13,.543A11.5,11.5,0,0,1,23.457,11H13Z",
    fill: "#7c0e6f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFilledIcon);
export default __webpack_public_path__ + "static/media/dashboardFilled_icon.91655eb90a33bb848bee43aedae7dc0c.svg";
export { ForwardRef as ReactComponent };